<template>
  <div class="dem-dev-cre">
    <table class="dem-dev-credito" cellspacing="0">
      <tbody>
        <tr class="odd">
          <th class="codigo">Devolução {{ cpntDemanda === 'dev_cliente' ? ' Cliente' : ' Fornecedor' }}</th>
          <th>
            Crédito gerado para:
            <App-Button :cpntIcone="'trocar'" :cpntClass="'btn btn-sm btn-warning'" style="float: right;" @onClick="() => { alterarContatoCre = !alterarContatoCre }" :title="'Trocar contato que receberá o crédito desta devolução.'"></App-Button>
          </th>
          <th class="codigo">Valor do Crédito</th>
          <th class="codigo">
            Crédito disponível
            <App-Button :cpntIcone="'impressora'" :cpntClass="'btn btn-sm btn-default'" style="margin-top: -2px; float: right; padding: 0px; margin-left: 5px; width: 22px; height: 22px; text-align: center;" @onClick="() => { demDevCreOnImprimirRecibo() }"></App-Button>
          </th>
        </tr>
        <tr class="even" style="clear: both;">
          <td align="right" class="codigo" id="no-style-td-odd">
            <b v-html="demDevCreFormatarCodigo"></b>
            <div v-html="cpntCreatedAt"></div>
          </td>
          <td align="right" id="no-style-td-even" class="contato" @click="demDevCreAbrirCartaoContato" style="cursor: pointer;">
            <template v-if="contatoCre !== null">
              <span v-html="contatoCre.nome"></span>
            </template>
          </td>
          <td align="right" id="no-style-td-even" style="width: 162px;">
            <span v-html="'R$ ' + cpntDemandaTotal.geral._credito"></span>
          </td>
          <td align="right" id="no-style-td-even" style="width: 162px;">
            <b style="font-size: 16px;" v-if="contatoCre !== null" v-html="'R$ ' + contatoCre._virtual_credito._CreditoDisponivel"></b>
          </td>
        </tr>
      </tbody>
    </table>


    <div class="botoes">
      <template v-if="[ 'NFe' ].indexOf(cpntPDocTp) !== -1 && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, [ 20 ], null, [ 38 ], null, [ 318 ], null, false) === true">
        <template v-if="cpntPDocAcao.danfe === '0'">
          <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" :cpntStatus="previsualizar !== '' && previsualizar === 'carregando' ? 'carregando' : ''" @onClick="() => { demDevCreOnEmitirNFe(true) }" v-if="$store.state.licenca.NFe_emissor !== 'mi' && (cpntPDocAcao.emitir === '1' || cpntPDocAcao.reemitir === '1')">
            Pré-Visualizar
            <br/>
            NF-e
          </App-Button>

          <App-Button :cpntClass="[ 'btn', 'btn-primary', 'btn-sm' ]" :cpntStatus="previsualizar !== '' && previsualizar === 'carregando' ? 'carregando' : ''" @onClick="() => { demDevCreOnEmitirNFe(false) }">
            <template v-if="cpntPDocAcao.emitir === '1'">
              Emitir NF-e
            </template>
            <template v-else-if="cpntPDocAcao.reemitir === '1'">
              Reemitir NF-e
            </template>
            <template v-else>
              Consultar Situação NF-e
            </template>
          </App-Button>
          

          <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" :cpntStatus="previsualizar !== '' && previsualizar === 'carregando' ? 'carregando' : ''" @onClick="() => { demDevCreOnAbrirDemanda() }">
            <template v-if="cpntPDocAcao.reemitir === '0'">
              Emitir NF-e depois,<br/>prefiro analisar todos os<br/>dados desta devolução antes.
            </template>
            <template v-else>
              Reemitir NF-e depois,<br/>prefiro analisar melhor os<br/>dados desta devolução.
            </template>
          </App-Button>
        </template>
        <template v-else>
          <App-Button :cpntClass="[ 'btn', 'btn-primary', 'btn-sm' ]" :cpntStatus="previsualizar !== '' && previsualizar === 'carregando' ? 'carregando' : ''" @onClick="() => { demDevCreAbrirDocumentoFiscal() }">
            <App-Icone :cpntTipo="'danfe-icon'"></App-Icone>
            DANFE
          </App-Button>

          <App-Button :cpntClass="[ 'btn', 'btn-warning', 'btn-sm' ]" :cpntStatus="previsualizar !== '' && previsualizar === 'carregando' ? 'carregando' : ''" @onClick="() => { demDevCreOnAbrirDemanda() }">
            <template v-if="$store.state.token.pdv === true">
              <App-Icone :cpntTipo="'pdv'"></App-Icone>
              Voltar para tela do pdv
            </template>
            <template v-else>
              <App-Icone :cpntTipo="'editar'"></App-Icone>
              Editar devolução
            </template>
          </App-Button>
        </template>
      </template>
      <template v-else>
        <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]" :cpntStatus="previsualizar !== '' && previsualizar === 'carregando' ? 'carregando' : ''" @onClick="() => { demDevCreOnAbrirDemanda() }">
          Finalizar devolução
        </App-Button>
      </template>
    </div>

    <DF-Log v-if="cpntPDocAcao.rejeicao === '1' && [ '', null, undefined, '0', 0 ].indexOf(cpntPDocDocs) === -1"
    :cpntDfId="Number(cpntPDocDocs)"
    :cpntDfLogTipo="'comunicacao'"
    :cpntMostrarBT="true"
    :cpntMostrarTab="false"
    ref='log_comunicacao'
    ></DF-Log>

    <!-- SETA O CAMPO PARA PRE-VISUALIZAR A NOTA FISCAL -->
    <RF-Dialog v-if="[ '', null, undefined, 'carregando' ].indexOf(previsualizar) === -1"
      :cpntStatus='(previsualizar === "carregando" || (previsualizar !== "carregando" && typeof previsualizar !== "string")) ? previsualizar : ""'
    :cpntLargura='"900px"'
    :cpntTitulo="'Pré-visualização da NF-e'"
    :cpntOnFecharDialog='demDevCrePreVisualizarFechar'>
      <template slot='conteudo'>
        <embed :src="'data:application/pdf;base64, ' + previsualizar" width="100%" height="100%" style="height: 100vh;" type="application/pdf">
      </template>
    </RF-Dialog>

    <!-- VERIFICA O QUE DEVE SER TROCADO -->
    <Demanda-Editar-Cabecalho-Trocar-Info v-if="[ '', null, undefined ].indexOf(alterarContatoCre) === -1 && alterarContatoCre === true"
    :cpntContatoId="contatoCre.id"

    :cpntDemanda="cpntDemanda"
    :cpntDemandaId="cpntDemandaId"
    :cpntTipo="'contato'"
    :cpntFecharFormulario="demDevCreTrocarContato"
    ></Demanda-Editar-Cabecalho-Trocar-Info>
  </div>
</template>

<style scoped>
.dem-dev-cre {
  max-width: 750px;
  margin: 0px auto;
  margin-top: -15px;
}

  .dem-dev-cre > table {
    width: 100%;
    margin-top: 20px;
  }
    .dem-dev-cre > table > tr > td:not(.meio) {
      width: 350px;
    }
    .dem-dev-cre > table > tr > td {
      vertical-align: top;
    }
    .dem-dev-cre > table > tr:first-child > td {
      padding: 2px 0px;
    }
    .dem-dev-cre > table > tr:first-child > td > button {
      padding: 0px;
      width: 30px;
      height: 20px;
    }

.dem-dev-credito {
  border: 1px solid #CCC;
  border-collapse: separate;
  background-color: transparent;
  border-radius: 5px;
}
  .dem-dev-credito tr:first-child th:first-child {
    border-top-left-radius: 5px;
  }
  .dem-dev-credito tr:first-child th:last-child {
    border-top-right-radius: 5px;
  }
  .dem-dev-credito tr:last-child td:first-child {
    border-bottom-left-radius: 5px;
  }
  .dem-dev-credito tr:last-child td:last-child {
    border-bottom-right-radius: 5px;
  }
  .dem-dev-credito tr th {
    border-left: 1px solid #32a6b0;
    text-align: center;
    background: #1d939f;
    color: #FFF;
  }
  .dem-dev-credito tr td {
    background: #FFF;
    color: #333 !important;
    border-left: 1px solid #D8D8D8;
    background: #FFF;
    color: #333;
  }
  .dem-dev-credito tr th, 
  .dem-dev-credito tr td {
    text-align: center;
    padding: 10px;
    margin: 0;
  }
  .dem-dev-credito tr td:first-child,
  .dem-dev-credito tr th:first-child {
    border-left: none;
  }
  .dem-dev-credito tr:last-child td,
  .dem-dev-credito tr:last-child th {
    border-bottom: none;
  }
  
  /* .dem-dev-credito tr td */
  .dem-dev-credito > tbody > tr > .contato {
    cursor: pointer;
  }
  .dem-dev-credito > tbody > tr > .codigo {
    width: 130px;
  }
    .dem-dev-credito > tbody > tr > .codigo > div {
      font-size: calc(100% - 3px);
      margin-top: 2px;
    }

.dem-dev-credito-tab {
  width: 350px;
  border: 1px solid #CCC;
  margin: 0px auto;
  border-collapse: separate;
  background-color: transparent;
  border-radius: 5px;
}
  .dem-dev-credito-tab tr:first-child th {
    border-top-left-radius: 5px;
  }
  .dem-dev-credito-tab tr:first-child td {
    border-top-right-radius: 5px;
  }
  .dem-dev-credito-tab tr:last-child th {
    border-bottom-left-radius: 5px;
  }
  .dem-dev-credito-tab tr:last-child td {
    border-bottom-right-radius: 5px;
  }
  .dem-dev-credito-tab tr th {
    border-bottom: 1px solid #32a6b0;
    text-align: left;
    background: #1d939f;
    color: #FFF;
  }
  .dem-dev-credito-tab tr td {
    background: #FFF;
    color: #333 !important;
    border-bottom: 1px solid #D8D8D8;
    background: #FFF;
    color: #333;
  }
  .dem-dev-credito-tab tr th, 
  .dem-dev-credito-tab tr td {
    padding: 10px;
    margin: 0;
  }
  .dem-dev-credito-tab tr td:first-child,
  .dem-dev-credito-tab tr th:first-child {
    border-left: none;
    width: 140px;
  }
  .dem-dev-credito-tab tr:last-child td,
  .dem-dev-credito-tab tr:last-child th {
    border-bottom: none;
  }

  .dem-dev-cre > .botoes {
    margin-top: 20px;
    text-align: center;
  }
    .dem-dev-cre > .botoes > button {
      margin: 0px 10px;
      width: 170px;
      height: 65px;
    }

</style>

<style>
  .dem-dev-cre > .df-logs > button {
    margin-top: 15px;
  }
  .dem-dev-cre > .botoes > button > span > span > svg {
    font-size: 20px;
    margin-right: 10px;
    vertical-align: -4px;
  }
  .dem-dev-cre > .botoes > button > span > img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },
      
      cpntIdCon: {
        required: true,
        type: String
      },
      cpntIdConNome: {
        required: true,
        type: String
      },
      cpntIdConCnpjCpf: {
        required: true,
        type: String
      },
      cpntIdConEmpresa: {
        required: true,
        type: String
      },
      cpntIdConPessoa: {
        required: true,
        type: String
      },
      cpntIdConStatus: {
        required: true,
        type: String
      },
      cpntCreatedAt: {
        required: true,
        type: String
      },
      cpntDemandaContatoCreditoId: {
        required: true,
        type: String
      },
      cpntPDocNFEmitida: {
        required: true
      },
      cpntPDocNatOpe: {
        required: true
      },
      cpntPDocTp: {
        required: true
      },
      cpntPDocAcao: {
        required: true
      },
      cpntPDocDocs: {
        required: true
      },

      cpntDemDevAlterarPagina: {
        required: true
      },
      cpntDemDevSetarStatusGeral: {
        required: true
      },
      cpntDemDevAtualizarDadosDemanda: {
        required: true
      }
    },
    components: {
      'Demanda-Editar-Cabecalho-Trocar-Info': () => import('@/components/demanda/Editar/Cabecalho/Demanda-Editar-Cabecalho-Trocar-Info'),
      'DF-Log': () => import('@/components/_geral/DF-Log.vue')
    },
    data: function () {
      return {
        time: '',
        contatoCre: null,
        alterarContatoCre: false,
        previsualizar: ''
      }
    },
    mounted: function () {
      // FAZ A BUSCA DOS DADOS DE CREDITO
      this.demDevCreBuscarValoresCredito()

      // VERIFICA SE DEVE FAZER UMA SUESTÃO DA NATURAZA DA OPERACAO
      this.demDevCreVerificarSugestaoNatOpe()
    },
    methods: {
      demDevCreTrocarContato: function (atualizar, id) {
        // VERIFICA SE DEVE ATUALIZAR A TELA
        if (atualizar === true) {
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }

          // SETA O STATUS DA TELA
          this.$emit('DEMANDA_TRAVAR_TELA', true)

          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

          // INICIA A VARIAVEL PARA RECEBER A ROTA
          var router = ''

          // INICIA O FORMULARIO
          var formData = {}

          // SETA O ID QUE DEVE ATUALIZAR
          formData[chaveD] = this.cpntDemandaId

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              router = '/demanda/dem-dev-cliente/id-con-dev-credito'
              formData.id_con_dev_credito = id
              break

            case 'dev_fornecedor':
              router = '/demanda/dem-dev-fornecedor/id-con-dev-credito'
              formData.id_con_dev_credito = id
              break
          }

          // ALTERA PARA PUT DE VENDA GERAL
          formData = { lot: [ formData ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = [ '', null, undefined ].indexOf(apiSuccess.lot) === -1 ? apiSuccess.lot[0] : { code: '200', message: apiSuccess.message }

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
      
                // MANDA ATUALIZAR OS DADOS DA DEMANDA
                this.cpntDemDevAtualizarDadosDemanda(this.cpntDemandaId, () => {})
                break

              default:
                this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true, () => {
                  this.cpntDemDevAtualizarDadosDemanda(this.cpntDemandaId, () => { this.$emit('DEMANDA_TRAVAR_TELA', false) })
                })
                break
            }
          }, this.cpntDemDevSetarStatusGeral, (apiValid, apiStatus) => {
            this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, {}, true, () => {
              this.cpntDemDevAtualizarDadosDemanda(this.cpntDemandaId, () => { this.$emit('DEMANDA_TRAVAR_TELA', false) })
            })
          })
        }

        // SETA O VETOR O VALOR DO VETOR
        this.alterarContatoCre = false
      },
      // demDevCreTrocarContato: function () {
      //   // INICIA O PARAMETRO
      //   var params = { tipo: 'CONSULTAR_CONTATO', selecionar: true, titulo: 'Selecione um contato para receber o crédito' }

      //   // SETA O CALLBACK QUE DEVE EXECUTAR
      //   params.callback = (atualizar, id) => {
      //     if (atualizar === true) {
      //       // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
      //       const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA
  
      //       // PEGA A CHAVE REFERENCIA
      //       var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

      //       // INICIA O FORMULARIO QUE SERÁ APRESENTADO
      //       var formData = {}

      //       // SETA O NUMERO DA DEMANDA
      //       formData[chaveD] = this.cpntDemandaId

      //       // SETA O ID DO NOVO CONTATO
      //       formData.id_con_dev_credito = id

      //       // CONVERTE O VALOR PARA LOT
      //       formData = { lot: [ formData ] }
  
      //       // FAZ A BUSCA DOS DADOS
      //       this.$store.state.comunicaAPI('/demanda/dem-dev-cliente/id-con-dev-credito', 'PUT', formData, (retorno) => {
      //         // PEGA O VALOR RECEBIDO
      //         retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : Object.assign(retorno, { code: '200', message: retorno.message })
    
      //         // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
      //         if (retorno.code !== '200') {
      //           this.demDevCreTratarValidacao(retorno.message, retorno.code)
      //         } else {
      //           // APRESENTA A MENSAGEM DE SUCESSO
      //           this.$store.state.TRATAR_RET_LOT_API(retorno)
    
      //           // MANDA ATUALIZAR OS DADOS DA DEMANDA
      //           this.cpntDemDevAtualizarDadosDemanda(null)
      //         }
      //       }, this.cpntDemDevSetarStatusGeral, this.demDevCreTratarValidacao)
      //     }
      //   }
        
      //   // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
      //   this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      // },
      demDevCreTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, {}, this).then(() => {        
          // SETA OS VALORES RECEBIDOS
          this.previsualizar = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // VERIFICA SE TEM CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      demDevCreBuscarValoresCredito: function () {
        // INICIA A QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1 } }

        // SETA OS CAMPOS QUE DEVE BUSCAR
        queryGet.field = {
          id: null,
          nome: null,
          cnpj_cpf: null,
          pessoa: null
        }

        // SETA O FIELD VIRTUAL
        queryGet.field_virtual = [ 'credito_cliente', 'credito_fornecedor' ]

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { f: 'id', o: '=', v: this.cpntDemandaContatoCreditoId }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, (retorno) => {
          // PEGA O NOME DA CHAVE QUE DEVE TRABALHAR
          var chave = this.cpntDemanda === 'dev_cliente' ? 'virtual_credito_cliente' : 'virtual_credito_fornecedor'
          
          // INICIA O VETOR
          retorno.data[0]._virtual_credito = {}

          // FORMATA OS NUMEROS RECEBIDOS
          for (var index in retorno.data[0][chave]) {
            retorno.data[0]._virtual_credito['_' + index] = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.data[0][chave][index])
          }

          // SETA OS DADOS DO CONTATO RECEBIDO
          this.contatoCre = retorno.data[0]

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, this.cpntDemDevSetarStatusGeral)
      },
      demDevCreVerificarSugestaoNatOpe: function () {
        // if (this.cpntPDocTp === 'NFe' && ([ '', null, undefined ].indexOf(this.cpntPDocNatOpe) !== -1 || confirm('Já existe uma Natureza da Operação digitada, deseja alterar para a sugestão do sistema?'))) {
        if (this.cpntPDocTp === 'NFe' && [ '', null, undefined ].indexOf(this.cpntPDocNatOpe) !== -1) {
          // SETA O NOME DA ROTA QUE DEVE CHAMAR
          var routerGet = ''
          var routerPut = ''

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              // SETA O NOME DA ROTA QUE DEVE PEGAR A SUGESTÃO DA NATURAZA DA OPERAÇÃO
              routerGet = '/demanda/df-sug-nat-operacao/get/dem_dev_cliente/'

              // SETA O NOME DA ROTA QUE DEVE PEGAR A SUGESTÃO DA NATURAZA DA OPERAÇÃO
              routerPut = '/demanda/dem-dev-cliente/p-doc-nat-ope'
              break


            case 'dev_fornecedor':
              // SETA O NOME DA ROTA QUE DEVE PEGAR A SUGESTÃO DA NATURAZA DA OPERAÇÃO
              routerGet = '/demanda/df-sug-nat-operacao/get/dem_dev_fornecedor/'

              // SETA O NOME DA ROTA QUE DEVE PEGAR A SUGESTÃO DA NATURAZA DA OPERAÇÃO
              routerPut = '/demanda/dem-dev-fornecedor/p-doc-nat-ope'

              break
          }

          // COMUNICA COM A API
          this.$store.state.comunicaAPI(routerGet, 'GET', this.cpntDemandaId, (retorno) => {
            if ([ '', null, undefined ].indexOf(retorno.data) === -1) {
              // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
              const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA
    
              // PEGA A CHAVE REFERENCIA
              var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

              // INICIA O FORMULARIO QUE SERÁ APRESENTADO
              var formData = {}

              // SETA O NUMERO DA DEMANDA
              formData[chaveD] = this.cpntDemandaId

              // SETA O ID DO NOVO CONTATO
              formData.p_doc_nat_ope = retorno.data

              // CONVERTE O VALOR PARA LOT
              formData = { lot: [ formData ] }

              // FAZ A BUSCA DOS DADOS
              this.$store.state.comunicaAPI(routerPut, 'PUT', formData, (retorno) => {
                // PEGA O VALOR RECEBIDO
                retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : Object.assign(retorno, { code: '200', message: retorno.message })

                // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
                if (retorno.code !== '200') {
                  this.demDevCreTratarValidacao(retorno.message, retorno.code)
                }
              }, this.cpntDemDevSetarStatusGeral, (apiValid, apiStatus) => { this.demDevCreTratarValidacao(apiValid, apiStatus) })
            }
          }, this.cpntDemDevSetarStatusGeral, (apiValid, apiStatus) => { this.demDevCreTratarValidacao(apiValid, apiStatus) })
        }
      },
      demDevCreOnEmitirNFe: function (preVisualizar = false) {
        // SETA OS VALORES RECEBIDOS
        this.previsualizar = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA AS VARIAVEIS
        var router = ''
        var method = ''
        var formData = {}

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        var acao = 'emitir'

        // VERIFICA A AÇÃO A UTILIZAR
        if (this.cpntPDocAcao.emitir !== '1') {
          acao = this.cpntPDocAcao.reemitir === '1' ? 'reemitir' : 'consultar'
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (acao) {
          case 'emitir':
            var mod = this.cpntDemanda === 'dev_cliente' ? '59' : '60'

            // SETA A ROTA QUE DEVE CHAMAR
            router = '/df/emitir'
            
            // SETA O FORMULARIO QUE DEVE SER ENVIADO
            formData = { j_ref: JSON.stringify([ { tp: 'p', m: mod, id: this.cpntDemandaId } ]) }

            // SETA A PRÉ VISUALIZAÇÃO
            if (preVisualizar === true) {
              formData.pre_visualizar = 'sim'
            }

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'POST'
            break

          case 'reemitir':
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/df/reemitir'
            
            // SETA O FORMULARIO QUE DEVE SER ENVIADO
            formData = { j_df: JSON.stringify([ this.cpntPDocDocs ]) }

            // SETA A PRÉ VISUALIZAÇÃO
            if (preVisualizar === true) {
              formData.pre_visualizar = 'sim'
            }

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'PUT'
            break

          case 'consultar':
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/df/consultar'
            
            // SETA O FORMULARIO QUE DEVE SER ENVIADO
            formData = { j_df: JSON.stringify([ this.cpntPDocDocs ]) }

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'PUT'
            break
        }
        
        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI(router, method, formData, (retorno) => {
          // PEGA O VALOR RECEBIDO
          retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : Object.assign(retorno, { code: '200', message: retorno.message })

          // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
          if (preVisualizar === true && retorno.code !== '200') {
            this.demDevCreTratarValidacao(retorno.message, retorno.code)
          } else if (preVisualizar === true) {
            // SETA OS VALORES RECEBIDOS
            this.previsualizar = retorno.data

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          } else {
            // APRESENTA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(retorno)

            // // VERIFICA SE DEVE ABRIR OU ATUALIZAR A DEMANDA
            // if (this.$store.state.token.pdv === true) {
            //   this.cpntDemDevAtualizarDadosDemanda(() => {
            //     // SETA OS VALORES RECEBIDOS
            //     this.previsualizar = ''
    
            //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            //     this.time = new Date().getTime()
            //   })
            // } else {
            //   this.demDevCreOnAbrirDemanda()
            // }

            // 22/12/2021 - 15:10
            // RAPHAEL PEDIU PARA FAZER A ALTERAÇÃO E EM TODAS AS TELAS FAZ A EMISSÃO 
            // SE DER ALGUM ERRO, CONTINUA NA TELA E NÃO ABRE MAIS O EDITAR DA DEMANDA
            this.cpntDemDevAtualizarDadosDemanda(() => {
              // SETA OS VALORES RECEBIDOS
              this.previsualizar = ''
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            })
          }
        }, this.cpntDemDevSetarStatusGeral, (apiValid, apiStatus) => { this.demDevCreTratarValidacao(apiValid, apiStatus) })
      },
      demDevCrePreVisualizarFechar: function () {
        // SETA OS VALORES RECEBIDOS
        this.previsualizar = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demDevCreOnAbrirDemanda: function () {
        this.cpntDemDevAlterarPagina(null)
      },
      demDevCreOnImprimirRecibo: function () {
        // INICIA O PARAMETRO QUE SERÁ USADO
        var params = {}

        // VERIFICA O PARAMETRO PARA CADA DEMANDA
        switch (this.cpntDemanda) {
          case 'dev_cliente':
            params = { name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'dev_cliente', id: this.contatoCre.id, tipo: 'rec-cre-cliente', formato: 'html' } }
            break
          
          case 'dev_fornecedor':
            params = { name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'dev_fornecedor', id: this.contatoCre.id, tipo: 'rec-cre-fornecedor', formato: 'html' } }
            break
        }

        // EXECUTA O PARAMETRO INFORMADO
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, 'iframe-hidden', {}, false)
      },
      demDevCreAbrirCartaoContato: function () {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: 'contato', id: this.contatoCre.id }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.demDevCreBuscarValoresCredito()
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      demDevCreAbrirDocumentoFiscal: function () {
        // SETA OS VALORES RECEBIDOS
        this.previsualizar = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'ABRIR_DOC_FISCAL', id: this.cpntPDocDocs, acao: 'imprimir', origem: 'df' }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = () => {
          setTimeout(() => {
            // SETA OS VALORES RECEBIDOS
            this.previsualizar = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, 0)
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
    },
    computed: {
      demDevCreFormatarCodigo: function () {
        // PEGA O VALOR RECEBIDO E CONVERTE EM STRING
        var valor = this.cpntDemandaId.toString()

        // FORMATA O VALOR RETORNADO
        return (valor.length <= 4 ? ('0000' + valor).slice(-4) : valor)
      },
    },
    watch: {
      cpntDemandaContatoCreditoId: function () {
        this.demDevCreBuscarValoresCredito()
      }
    }
  }
</script>
